import { Routes } from '@angular/router';

import { courtResolver } from '@shared/resolvers';

import { APP_ROUTES_SEGMENTS } from '../enums/app-routes-segments.enum';
import { TENANT_ROUTES_CONFIG } from '../constants/tenant-routes-config.constants';
import { tenantClearResolver } from '../resolvers/tenant-clear.resolver';
import { tenantSetterResolver } from '../resolvers/tenant-setter.resolver';

// Every route served inside a county. Mounted under /:state/:court while
// counties share a domain, and at the root once each county owns one.
export const COUNTY_ROUTES: Routes = [
  {
    resolve: { court: courtResolver },
    path: `${APP_ROUTES_SEGMENTS.params.portal}/${APP_ROUTES_SEGMENTS.access}`,
    loadChildren: () =>
      import('@shared/features/access/access.routes').then(
        (r) => r.AccessRoutes,
      ),
  },
  ...TENANT_ROUTES_CONFIG.map((app) => ({
    path: app.path,
    data: app.data,
    resolve: { court: courtResolver, tenant: tenantSetterResolver },
    loadChildren: () => app.loadChildren(),
  })),
  {
    path: APP_ROUTES_SEGMENTS.dashboard,
    children: [
      {
        path: `${APP_ROUTES_SEGMENTS.admin}`,
        pathMatch: 'prefix' as const,
        resolve: { court: courtResolver, tenant: tenantClearResolver },
        loadChildren: () =>
          import('@domains/admin/admin.routes').then((r) => r.ADMIN_ROUTES),
      },
      {
        path: `${APP_ROUTES_SEGMENTS.applications}`,
        pathMatch: 'prefix' as const,
        resolve: { court: courtResolver, tenant: tenantClearResolver },
        loadChildren: () =>
          import('@shared/features/multiple-applications/applications.routes').then(
            (r) => r.APPLICATIONS_ROUTES,
          ),
      },
      {
        path: `${APP_ROUTES_SEGMENTS.wip}`,
        pathMatch: 'prefix' as const,
        loadChildren: () =>
          import('@domains/wip/wip.routes').then((r) => r.WIP_ROUTES),
      },
    ],
  },
];
